export default [
  { id: 'nameFirst', label: 'First Name', component: 'Input' },
  { id: 'nameLast', label: 'Last Name', component: 'Input' },
]